module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component admin-outer-wrapper"
  }, [_c('SessionTimeoutWarning'), _vm._v(" "), _c('div', {
    staticClass: "admin-nav"
  }, [_c('ul', [(_vm.can('settings')) ? _c('li', {
    class: _vm.$route.name === 'admin-settings' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-settings'
      }
    }
  }, [_vm._v("Inställningar")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('accomodations')) ? _c('li', {
    class: _vm.$route.name === 'admin-accomodations' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-accomodations'
      }
    }
  }, [_vm._v("Boende")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('commands')) ? _c('li', {
    class: _vm.$route.name === 'admin-command-sync' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-command-sync'
      }
    }
  }, [_vm._v("Synka")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('texts')) ? _c('li', {
    class: _vm.$route.name === 'admin-texts' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-texts'
      }
    }
  }, [_vm._v("Texter")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('orderlist')) ? _c('li', {
    class: _vm.$route.name === 'admin-stats-orders' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-stats-orders'
      }
    }
  }, [_vm._v("Ordrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('emailreport')) ? _c('li', {
    class: _vm.$route.name === 'admin-email-report' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-email-report'
      }
    }
  }, [_vm._v("E-postrapport")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('notifications')) ? _c('li', {
    class: _vm.$route.name === 'admin-notifications' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-notifications'
      }
    }
  }, [_vm._v("Logg")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('gdpr')) ? _c('li', {
    staticClass: "disabled",
    class: _vm.$route.name === 'admin-gdpr-cleanup' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-gdpr-cleanup'
      }
    }
  }, [_vm._v("GDPR")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('translations')) ? _c('li', {
    staticClass: "disabled",
    class: _vm.$route.name === 'admin-translations' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-translations'
      }
    }
  }, [_vm._v("Översättning")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('users')) ? _c('li', {
    class: _vm.$route.name === 'admin-users' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-users'
      }
    }
  }, [_vm._v("Användare")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('tokens')) ? _c('li', {
    class: _vm.$route.name === 'admin-tokens' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-tokens'
      }
    }
  }, [_vm._v("Tokens")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('logs')) ? _c('li', {
    class: _vm.$route.name === 'admin-logs' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-logs'
      }
    }
  }, [_vm._v("Ändringslogg")])], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Gå till logga ut")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4c9ae66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/AdminPage.vue
// module id = 1047
// module chunks = 0